import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogRef
} from '@angular/material/dialog';
import { AreaService } from '../../../../services/area.service';

interface DeleteAreaDialogData {
  areas?: Set<string>;
  selectAll?: boolean;
  project_id: string;
  exclude_area_ids?: string[];
  include_area_ids?: string[];
  alone?: boolean;
}

@Component({
  selector: 'frmg-delete-area-dialog',
  templateUrl: './delete-area-dialog.component.html',
  styleUrls: ['./delete-area-dialog.component.scss'],
  imports: [MatButton, MatDialogClose, CommonModule]
})
export class DeleteAreaDialogComponent {
  public isLoading = false;
  public dryRunResult: any = null;
  public showDryRun = false;

  constructor(
    private dialogRef: MatDialogRef<DeleteAreaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteAreaDialogData,
    private areaService: AreaService
  ) {}

  public closeDialog(
    result: { task_id?: string; error?: string } | string | boolean
  ): void {
    this.dialogRef.close(result);
  }

  public previewDelete(): void {
    this.isLoading = true;

    this.areaService
      .deleteBulkAreasDryRun(
        this.data.project_id,
        this.data.exclude_area_ids,
        this.data.include_area_ids,
        undefined
      )
      .subscribe({
        next: (resp) => {
          this.isLoading = false;
          this.dryRunResult = resp;
          this.showDryRun = true;
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Preview failed:', error);
        }
      });
  }

  public delete(): void {
    this.isLoading = true;

    this.areaService
      .deleteBulkAreas(
        this.data.project_id,
        this.data.exclude_area_ids,
        this.data.include_area_ids,
        undefined
      )
      .subscribe({
        next: (resp) => {
          this.isLoading = false;
          this.closeDialog(resp);
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Delete failed:', error);
          this.closeDialog({ error: error.message || 'Delete failed' });
        }
      });
  }
}
